import { render, staticRenderFns } from "./ReporteIsr.vue?vue&type=template&id=24d6e8d7&"
import script from "./ReporteIsr.vue?vue&type=script&lang=js&"
export * from "./ReporteIsr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports